/* eslint-disable no-console */
import createDataContext from './createDataContext';
import { api } from '../api/api';

const linkBuilderReducer = (state, action) => {
  switch (action.type) {
    case 'get_products':
      return { ...state, availableProducts: action.payload };
    case 'add_cart_item':
      return {
        ...state,
        cartItems: [...state.cartItems, action.payload],
      };
    case 'update_cart_item':
      return {
        ...state,
        cartItems: state.cartItems.map((item) => (item.id === action.payload.id ? action.payload : item)),
      };
    case 'remove_cart_item':
      return {
        ...state,
        cartItems: state.cartItems.filter((item) => item.id !== action.payload),
      };
    case 'reorder_cart_items':
      return { ...state, cartItems: action.payload };
    case 'clear_cart':
      return { ...state, cartItems: [] };
    case 'set_loading':
      return { ...state, isLoading: action.payload };
    case 'save_template':
      return {
        ...state,
        templates: [...state.templates, action.payload],
      };
    case 'get_templates':
      return { ...state, templates: action.payload };
    case 'delete_template':
      return {
        ...state,
        templates: state.templates.filter((template) => template._id !== action.payload),
      };
    case 'load_template':
      return { ...state, cartItems: action.payload };
    default:
      return state;
  }
};

const getProducts = (dispatch) => {
  return async () => {
    dispatch({ type: 'set_loading', payload: true });
    try {
      const response = await api.get('/stickyProducts', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      dispatch({ type: 'get_products', payload: response.data });
    } catch (err) {
      console.log(err);
    }
    dispatch({ type: 'set_loading', payload: false });
  };
};

const addCartItem = (dispatch) => {
  return (item) => {
    dispatch({ type: 'add_cart_item', payload: item });
  };
};

const updateCartItem = (dispatch) => {
  return (item) => {
    dispatch({ type: 'update_cart_item', payload: item });
  };
};

const removeCartItem = (dispatch) => {
  return (id) => {
    dispatch({ type: 'remove_cart_item', payload: id });
  };
};

const reorderCartItems = (dispatch) => {
  return (items) => {
    dispatch({ type: 'reorder_cart_items', payload: items });
  };
};

const clearCart = (dispatch) => {
  return () => {
    dispatch({ type: 'clear_cart' });
  };
};

const saveTemplate = (dispatch) => {
  return async (template) => {
    try {
      const response = await api.post('/linkBuilderTemplates', template, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      dispatch({ type: 'save_template', payload: response.data });
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };
};

const getTemplates = (dispatch) => {
  return async () => {
    try {
      const response = await api.get('/linkBuilderTemplates', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      dispatch({ type: 'get_templates', payload: response.data });
    } catch (err) {
      console.log(err);
    }
  };
};

const deleteTemplate = (dispatch) => {
  return async (id) => {
    try {
      await api.delete(`/linkBuilderTemplates/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      dispatch({ type: 'delete_template', payload: id });
    } catch (err) {
      console.log(err);
    }
  };
};

const loadTemplate = (dispatch) => {
  return (cartItems) => {
    dispatch({ type: 'load_template', payload: cartItems });
  };
};

const createSharedLink = (dispatch) => {
  return async (data) => {
    try {
      const response = await api.post('/sharedLinks', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };
};

export const { Context, Provider } = createDataContext(
  linkBuilderReducer,
  {
    getProducts,
    addCartItem,
    updateCartItem,
    removeCartItem,
    reorderCartItems,
    clearCart,
    saveTemplate,
    getTemplates,
    deleteTemplate,
    loadTemplate,
    createSharedLink,
  },
  { availableProducts: [], cartItems: [], templates: [], isLoading: false }
);
